import SignUpForm from "../../components/auth/SignUpForm";
import auth from '../../components/auth/AuthForms.module.css';
const SignUpPage = () => {
    return (
        <main className={`${auth.login} mx-auto row text-white`}>
            <section className="col  d-flex justify-content-end">
                <h1 id="bienvenida" className="m-0">"Reserva <span className={auth.highlight}>fácil</span> e infórmate del estado y disponibilidad de cada equipo de nuestro: Centro de Operaciones y Logística <span className={auth.highlightGreen}>(COL)</span> de Ecoturismo".</h1>
            </section>
            <section className="col  d-flex justify-content-start">
                <SignUpForm />
            </section>
        </main>
    )
}
export default SignUpPage;